<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jQczIc/tc-custom/9781609943561.jpg?1741154947456" alt="This image is the cover for the book How to Make Collaboration Work"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">How to Make Collaboration Work
      </h1>
      <p class="bookDescription body article font2">
        <p>Every day we work with others to solve problems and make decisions, but the experience is often stressful, frustrating, and inefficient. In How to Make Collaboration Work, David Straus, a pioneer in the field of group problem solving, introduces five principles of collaboration that have been proven successful time and again in nearly every conceivable setting. Straus draws on his thirty years of personal and professional experience to show how these principles have been applied by organizations as diverse as Ford Motor Company, the U.S. Environmental Protection Agency, Harvard Business School Publishing, Boston Public Schools, Kaiser Permanente, the city of Denver, and many others. How to Make Collaboration Work shows how collaboration can become a joy rather than a chore-a kind of chemical reaction that releases far more energy than it consumes.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David A Straus
      </h2>
      
      <p class="authorDescription body article">David A. Straus</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett-Koehler Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?62063e3e